import React from "react";

import { Container, Panel } from "cortex/ui/src/view/layout";

export default function Error404View() {
  return (
    <Container hideBox title="404 Not Found">
      <Panel>Sorry, that page does not exist.</Panel>
    </Container>
  );
}
